// Collapsing long agent answer tables. Only data rows count: a header <tr> of <th> cells isn't
// content, so "header + 5 schools" must not read as "Show 1 more rows". Collapsing removes the
// extra rows rather than cutting the HTML off, which used to keep every row and hide the text
// after the table instead (e.g. the guest "Sign in or sign up" line).

const ROW_PATTERN = /<tr[^>]*>[\s\S]*?<\/tr>/gi;
const HEADER_CELL = /<th[\s>]/i;

interface RowSpan {
  start: number;
  end: number;
}

function dataRows(message: string): RowSpan[] {
  const rows: RowSpan[] = [];
  const pattern = new RegExp(ROW_PATTERN.source, ROW_PATTERN.flags);
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(message)) !== null) {
    if (!HEADER_CELL.test(match[0])) {
      rows.push({ start: match.index, end: match.index + match[0].length });
    }
  }
  return rows;
}

export function hiddenTableRowCount(message: string, maxRows: number): number {
  if (!message || !/<table/i.test(message)) return 0;
  return Math.max(0, dataRows(message).length - maxRows);
}

export function collapseTableRows(message: string, maxRows: number): string {
  if (!hiddenTableRowCount(message, maxRows)) return message || '';
  // Remove from the end so earlier offsets stay valid.
  return dataRows(message)
    .slice(maxRows)
    .reverse()
    .reduce((html, row) => html.slice(0, row.start) + html.slice(row.end), message);
}
